module.exports = __webpack_public_path__ + "img/learnModelbgdec-line.d3df7fa2.png";